/**
 * Nav Cart Dropdown
 * @param {number} price
 */
export function formatPrice(price) {
  return price.toLocaleString('da-DK', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).replace(',00', '') + ' DKK'
}
